import React from 'react'
import styled from 'styled-components'

import CheckIcon from '../../../lib/assets/icons/check-status.svg'
import WarningIcon from '../../../lib/assets/icons/warning-orange.svg'
import { BREAKPOINT } from '../constants'

const RequirementContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  justify-content: flex-start;
  padding: 0;
  margin-top: -5px;
  margin-left: 15px;
  box-sizing: border-box;

  @media (max-width:  ${BREAKPOINT.SMALL}) {
    flex-direction: column;
  }
`

const RequirementColumn = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 12px;
`

const RequirementItem = styled.div`
  margin: 0;
  height: 25px;
  display: flex;
  align-items: center;
  width: 200px;

  color: ${props => props.isValid ? 'black' : '#aeaeae'};
`

const SuccessIcon = styled.img.attrs({
  src: CheckIcon
})`
  margin-left: 2px;
  padding-top: 2px;
  width: 17px;
`

const ErrorIcon = styled.img.attrs({
  src: WarningIcon
})`
  height: 10px;
  margin-left: 9px;
`

const Requirements = props => {
  const { passwordTouched, checkPasswordErrors } = props

  const showSuccess = requirement =>
    passwordTouched && !checkPasswordErrors[requirement]
  const showError = requirement =>
    passwordTouched && checkPasswordErrors[requirement]

  const renderValidation = requirement => {
    return (
      <span>
        {showSuccess(requirement) && <SuccessIcon />}
        {showError(requirement) && (
          <ErrorIcon />
        )}
      </span>
    )
  }

  return (
    <RequirementContainer>
      <RequirementColumn>
        <RequirementItem
          isValid={passwordTouched && !checkPasswordErrors.hasLowerCase}
        >
          One lowercase character
          {renderValidation('hasLowerCase')}
        </RequirementItem>
        <RequirementItem
          isValid={passwordTouched && !checkPasswordErrors.hasUpperCase}
        >
          One uppercase character
          {renderValidation('hasUpperCase')}
        </RequirementItem>
        <RequirementItem
          isValid={passwordTouched && !checkPasswordErrors.hasMinimumChar}
        >
          8 Letters minimum
          {renderValidation('hasMinimumChar')}
        </RequirementItem>
      </RequirementColumn>
      <RequirementColumn>
        <RequirementItem
          isValid={passwordTouched && !checkPasswordErrors.hasNumber}
        >
          One number
          {renderValidation('hasNumber')}
        </RequirementItem>
        <RequirementItem
          isValid={
            passwordTouched && !checkPasswordErrors.doesNotContainUsername
          }
        >
          Does not contain part of name
          {renderValidation('doesNotContainUsername')}
        </RequirementItem>
      </RequirementColumn>
    </RequirementContainer>
  )
}

export default Requirements
